export function getNextClass(standard) {
    const classSequence = [
        "Nursery",
        "LKG",
        "UKG",
        "1st",
        "2nd",
        "3rd",
        "4th",
        "5th",
        "6th",
        "7th",
        "8th",
        "9th",
        "10th",
        "11th",
        "12th"
    ];

    const index = classSequence.findIndex(
        item => item.toLowerCase() === standard?.trim().toLowerCase()
    );

    return index >= 0 && index < classSequence.length - 1
        ? classSequence[index + 1]
        : null;
};